<script>
import { defineAsyncComponent } from "vue";
import { Head, Link, useForm } from '@inertiajs/vue3';

export default {
    components: {
        BreezeLayout: defineAsyncComponent(() => import('@/Layouts/Authenticated.vue')),
        BreezeButton: defineAsyncComponent(() => import('@/Components/Button.vue')),
        BreezeInput: defineAsyncComponent(() => import('@/Components/Input.vue')),
        BreezeLabel: defineAsyncComponent(() => import('@/Components/Label.vue')),
        BreezeValidationErrors: defineAsyncComponent(() => import('@/Components/ValidationErrors.vue')),
        Head,
        Link,
        useForm,
    },

    props: {
        brand_slugs: Object,
    },

    setup() {
        const form = useForm({
            id: '',
            name: '',
            secret: '',
            brand_slug: '',
            redirect: '',
        });

        const submit = () => {
            form.post(route('clients.store'));
        };

        return {
            form,
            submit
        };
    }
}
</script>
<template>
    <Head title="Add Client"/>

    <BreezeLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                <Link :href="route('clients.index')">Clients</Link> / Add client
            </h2>

        </template>

    <div class="py-12">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

            <div class="bg-gray-100">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <div class="mt-10 sm:mt-0">
                        <div class="md:grid md:grid-cols-3 md:gap-6">
                            <div class="md:col-span-1">
                                <div class="px-4 sm:px-0">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">Adding new client</h3>
                                </div>
                            </div>
                            <div class="mt-5 md:mt-0 md:col-span-2">

                                <form @submit.prevent="submit">

                                    <div class="shadow overflow-hidden sm:rounded-md">
                                        <div class="px-4 py-5 bg-white sm:p-6">

                                            <BreezeValidationErrors class="mb-4"/>

                                            <div class="grid grid-cols-6 gap-6">

                                                <div class="col-span-6">
                                                    <BreezeLabel
                                                        for="name"
                                                        value="Client name"
                                                        extra="This is client name used by the BGS as client identifier" />
                                                    <BreezeInput
                                                        id="name"
                                                        type="text"
                                                        v-model="form.name"
                                                        autofocus
                                                        required
                                                        autocomplete="name" />
                                                </div>

                                                <div class="col-span-6">
                                                    <BreezeLabel
                                                        for="redirect"
                                                        value="Client secret"
                                                        extra="Client secret will be hashed in the database"
                                                    />
                                                    <BreezeInput
                                                        id="secret"
                                                        type="text"
                                                        v-model="form.secret"
                                                        required
                                                        autocomplete="secret" />
                                                </div>

                                                <div class="col-span-6">
                                                    <BreezeLabel
                                                        for="redirect"
                                                        value="Redirect URL" />
                                                    <BreezeInput
                                                        id="redirect"
                                                        type="text"
                                                        v-model="form.redirect"
                                                        required
                                                        autocomplete="redirect" />
                                                </div>


                                                <div class="col-span-6 sm:col-span-4">
                                                  <BreezeLabel
                                                      for="brand_slug"
                                                      value="Brand slug"
                                                      extra="Brand slug for client" />
                                                  <BreezeInput
                                                      id="brand_slug"
                                                      type="text"
                                                      v-model="form.brand_slug"
                                                      required
                                                      autofocus
                                                      autocomplete="brand_slug" />
                                                </div>

                                            </div>
                                        </div>

                                        <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">

                                            <BreezeButton
                                                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                :class="{ 'opacity-25': form.processing }"
                                                :disabled="form.processing">
                                                Submit
                                            </BreezeButton>

                                        </div>

                                    </div>


                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    </BreezeLayout>

</template>
